import React from "react";
import NotificationCard from "../../components/dashboard/notification-card";

const Notifications = () => {
  return (
    <div className="flex flex-col gap-2 h-screen w-full px-5">
      <div className="flex items-center w-full py-5">
        <h1 className="text-[32px] font-[400] w-full text-center optima">Notifications</h1>
      </div>
      <NotificationCard />
      <NotificationCard />
      <NotificationCard />
      <NotificationCard />
      <NotificationCard />
      <NotificationCard />
      <NotificationCard />
      <NotificationCard />
    </div>
  );
};

export default Notifications;
